var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuarantorBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 4C9 5.65685 7.65685 7 6 7C4.34315 7 3 5.65685 3 4C3 2.34315 4.34315 1 6 1C7.65685 1 9 2.34315 9 4Z",
    fill: "#B7DDFD",
    stroke: "#5E8EB7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1181_34373",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.105 6.94445L3.5 11.4995L6 9.99945L8.5 11.4995L7.895 6.93945"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.105 6.94445L3.5 11.4995L6 9.99945L8.5 11.4995L7.895 6.93945",
    fill: "#B7DDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.895 7.43945C8.17114 7.43945 8.395 7.2156 8.395 6.93945C8.395 6.66331 8.17114 6.43945 7.895 6.43945V7.43945ZM4.105 6.43945C3.82886 6.43945 3.605 6.66331 3.605 6.93945C3.605 7.2156 3.82886 7.43945 4.105 7.43945V6.43945ZM7.895 6.43945H4.105V7.43945H7.895V6.43945ZM5.09629 7.07612C5.16901 6.52864 4.78414 6.02588 4.23666 5.95316C3.68919 5.88044 3.18642 6.26531 3.11371 6.81279L5.09629 7.07612ZM3.5 11.4995L2.50871 11.3678C2.45815 11.7484 2.63002 12.1244 2.95096 12.3353C3.2719 12.5461 3.68522 12.5545 4.0145 12.3569L3.5 11.4995ZM6 9.99945L6.5145 9.14196C6.19781 8.95195 5.80219 8.95195 5.4855 9.14196L6 9.99945ZM8.5 11.4995L7.9855 12.3569C8.31476 12.5545 8.72804 12.5461 9.04898 12.3353C9.36991 12.1245 9.54181 11.7486 9.49131 11.3679L8.5 11.4995ZM8.88631 6.80793C8.81368 6.26044 8.31096 5.8755 7.76348 5.94814C7.21599 6.02078 6.83105 6.52349 6.90369 7.07098L8.88631 6.80793ZM3.11371 6.81279L2.50871 11.3678L4.49129 11.6311L5.09629 7.07612L3.11371 6.81279ZM4.0145 12.3569L6.5145 10.8569L5.4855 9.14196L2.9855 10.642L4.0145 12.3569ZM5.4855 10.8569L7.9855 12.3569L9.0145 10.642L6.5145 9.14196L5.4855 10.8569ZM9.49131 11.3679L8.88631 6.80793L6.90369 7.07098L7.50869 11.631L9.49131 11.3679Z",
    fill: "#5E8EB7",
    mask: "url(#path-2-inside-1_1181_34373)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuarantorBlue);
export default __webpack_public_path__ + "static/media/guarantor-blue.87241e5d457c1636d50ef7871ef48201.svg";
export { ForwardRef as ReactComponent };